import {
  Checkbox,
  Divider,
  Grid,
  Select,
  Space,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { Calendar } from 'tabler-icons-react';
import { GenderData } from '../../../../data/gender-data.array';
import { Gender } from '../../../../enums/gender-enums';
import { MerchantOnboardingFormValues } from '../../../../type/merchant-onboarding-form-values.types';
import PhoneCountryCodeIcon from '../../../icons/phone-country-code-icon.component';

interface RepresentativeEscalationInformationProps {
  form: UseFormReturnType<MerchantOnboardingFormValues>;
}
function RepresentativeEscalationInformation(
  props: RepresentativeEscalationInformationProps
) {
  const { form } = props;

  const label = {
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    position: 'Position',
    emailAddress: 'Email address',
    contactNumber: 'Contact number',
    dateOfBirth: 'Birthdate',
    tin: 'TIN',
    sss: 'SSS',
    aMothersMaidenName: "Mother's maiden name",
    aGender: 'Gender',
    aAubNationalityCode: 'AUB nationality code',
    aAubDeviceId: 'AUB device ID',
    aAubIdCode: 'AUB ID code',
    aAubIdNumber: 'AUB ID number',
    aAubRegionCode: 'AUB region code',
  };
  const placeHolder = {
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    position: 'Position',
    emailAddress: 'email@email.com',
    contactNumber: 'Contact number',
    dateOfBirth: 'Select Birthdate',
    tin: 'TIN',
    sss: 'SSS',
    aMothersMaidenName: "Mother's maiden name",
    aGender: 'Gender',
    aAubNationalityCode: 'AUB nationality code',
    aAubDeviceId: 'AUB device ID',
    aAubIdCode: 'AUB ID code',
    aAubIdNumber: 'AUB ID number',
    aAubRegionCode: 'AUB region code',
  };

  return (
    <>
      <Grid data-cy={'authorizedRegion'}>
        <Grid.Col>
          <Title order={3} style={{ fontWeight: 600 }}>
            Representative's Information
          </Title>

          <Text color='gray' mb={20}>
            Help us get to know you better
          </Text>
        </Grid.Col>

        <Grid.Col>
          <TextInput
            placeholder={placeHolder.firstName}
            label={label.firstName}
            value={form.values.aFirstName}
            onChange={(event) => {
              form.setFieldValue('aFirstName', event.currentTarget.value);
            }}
            error={form.errors.aFirstName}
            data-cy='firstName'
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.middleName}
            label={label.middleName}
            disabled={form.values.isAMNameDisabled}
            value={form.values.aMiddleName}
            onChange={(event) => {
              form.setFieldValue('aMiddleName', event.currentTarget.value);
            }}
            error={form.errors.aMiddleName}
            data-cy='middleName'
          />
          <Space my='xs' />
          <Checkbox
            label="I don't have a middle name"
            checked={form.values.isAMNameDisabled}
            onChange={() => {
              let value = !form.values.isAMNameDisabled;

              form.setFieldValue(
                'isAMNameDisabled',

                value
              );
              form.setFieldValue('aMiddleName', !value ? '' : '.');
            }}
            data-cy='noMiddleName'
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.lastName}
            label={label.lastName}
            value={form.values.aLastName}
            onChange={(event) => {
              form.setFieldValue('aLastName', event.currentTarget.value);
            }}
            error={form.errors.aLastName}
            data-cy='lastName'
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.position}
            label={label.position}
            value={form.values.aPosition}
            onChange={(event) => {
              form.setFieldValue('aPosition', event.currentTarget.value);
            }}
            error={form.errors.aPosition}
            data-cy='position'
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.emailAddress}
            label={label.emailAddress}
            value={form.values.aEmailAddress}
            onChange={(event) => {
              form.setFieldValue(
                'aEmailAddress',

                event.currentTarget.value
              );
            }}
            error={form.errors.aEmailAddress}
            data-cy='emailAddress'
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <TextInput
            label={label.contactNumber}
            value={form.values.aContactNumber}
            onChange={(event) => {
              form.setFieldValue(
                'aContactNumber',

                event.currentTarget.value
              );
            }}
            error={form.errors.aContactNumber}
            icon={<PhoneCountryCodeIcon />}
            iconWidth={48}
            maxLength={30}
            data-cy='contactNumber'
          />
        </Grid.Col>
        <Grid.Col xs={12} sm={6}>
          <DatePicker
            icon={<Calendar />}
            placeholder={placeHolder.dateOfBirth}
            label={label.dateOfBirth}
            value={form.values.aDateOfBirth}
            onChange={(value: Date) => {
              form.setFieldValue('aDateOfBirth', value);
            }}
            error={form.errors.aDateOfBirth}
            data-cy={'aDateOfBirth'}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aMothersMaidenName}
            label={label.aMothersMaidenName}
            value={form.values.aMothersMaidenName}
            onChange={(event) => {
              form.setFieldValue(
                'aMothersMaidenName',
                event.currentTarget.value
              );
            }}
            error={form.errors.aMothersMaidenName}
          />
        </Grid.Col>
        <Grid.Col>
          <Select
            placeholder={placeHolder.aGender}
            label={label.aGender}
            value={form.values.aGender}
            data={GenderData}
            onChange={(value: Gender) => {
              form.setFieldValue('aGender', value);
            }}
            error={form.errors.aGender}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aAubNationalityCode}
            label={label.aAubNationalityCode}
            value={form.values.aAubNationalityCode}
            onChange={(event) => {
              form.setFieldValue(
                'aAubNationalityCode',
                event.currentTarget.value
              );
            }}
            error={form.errors.aAubNationalityCode}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aAubDeviceId}
            label={label.aAubDeviceId}
            value={form.values.aAubDeviceId}
            onChange={(event) => {
              form.setFieldValue('aAubDeviceId', event.currentTarget.value);
            }}
            error={form.errors.aAubDeviceId}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aAubIdCode}
            label={label.aAubIdCode}
            value={form.values.aAubIdCode}
            onChange={(event) => {
              form.setFieldValue('aAubIdCode', event.currentTarget.value);
            }}
            error={form.errors.aAubIdCode}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aAubIdNumber}
            label={label.aAubIdNumber}
            value={form.values.aAubIdNumber}
            onChange={(event) => {
              form.setFieldValue('aAubIdNumber', event.currentTarget.value);
            }}
            error={form.errors.aAubIdNumber}
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aAubRegionCode}
            label={label.aAubRegionCode}
            value={form.values.aAubRegionCode}
            onChange={(event) => {
              form.setFieldValue('aAubRegionCode', event.currentTarget.value);
            }}
            error={form.errors.aAubRegionCode}
          />
        </Grid.Col>

        <Grid.Col>
          <Divider my='md' />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default RepresentativeEscalationInformation;
